import request from "./request";
/**
 * 获取失败贴文列表
 * @param pageNumber 当前页数
 * @param pageSize 页数大小
 */
export default async function getFailPosting(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  return await request.get("/spin/dataSend/getFailPosting", {
    params: { ...defaultParams, ...params },
  });
}
